module.exports = __webpack_public_path__ + "img/coming-soon.3c037ed8.svg";